import type { Thunk } from 'state/state.common';

import { priceImprovementRejected, priceImprovementValidated } from './priceImprovementResponse.actions';

export function priceImprovementRejectedThunk(rfpiId: string, quoteId: string): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        priceImprovementResponse: { getPriceImprovementComment },
      },
    },
  ) => {
    const state = getState();
    const comment = getPriceImprovementComment(state, rfpiId);
    dispatch(priceImprovementRejected(rfpiId, quoteId, comment));
  };
}

export function priceImprovementValidatedThunk(rfpiId: string, quoteId: string): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        priceImprovementResponse: { getPriceImprovementComment, getPriceImprovementAcceptablePriceAdjustment },
      },
    },
  ) => {
    const state = getState();
    const comment = getPriceImprovementComment(state, rfpiId);
    const acceptablePriceAdjustment = getPriceImprovementAcceptablePriceAdjustment(state, rfpiId);
    if (acceptablePriceAdjustment === undefined) {
      return;
    }
    dispatch(priceImprovementValidated(rfpiId, quoteId, acceptablePriceAdjustment, comment));
  };
}
